export const PRODUCT_ID = 'W128G1m_pro_promo_mail';

export enum EFeatures {
    space = 'space',
    ad = 'ad',
    mail = 'mail',
    support = 'support',
    upload = 'upload',
    safety = 'safety',
    interest = 'interest',
    document = 'document',
    gift = 'gift',
    settings = 'settings',
    quota = 'quota',
}

export enum ETabs {
    quota = 'quota',
    features = 'features',
    tariffs = 'tariffs',
    questions = 'questions',
    apps = 'apps',
    feedback = 'feedback',
    help = 'help',
    cleaner = 'cleaner',
}

export const QuotaLandingHashTabs = {
    '#price': ETabs.tariffs,
    '#start': ETabs.features,
    '#cleaner': ETabs.cleaner,
    '#faq': ETabs.questions,
};
